import { addToCalendarLink } from './calendars'

const postSessionRegistration = (options, setState, state ) => {
  const data = options.data
  const { session } = state
  window.api.post(`/virtual_portal/toggle_registration/${data.id}`).then((response) => {
    const reg_status = response.data.event_session_registration.registration_status
    session.registration_status = reg_status
    session.event_session_registration_virtual_platform_url = response.data.event_session_registration.event_session_registration_virtual_platform_url
    if (reg_status === 'double_booked') {
      setState({
        showDoubleBookedModal: true
      })
      return false
    }
    if (reg_status === 'session_full') {
      setState({
        showSessionFullModal: true
      })
      return false
    }
    if (reg_status === 'un_register') {
      setState({
        genericModalIsOpen: true,
        genericModalContent: '<h4>This session has been added to your schedule</h4><br>',
        modalCalendarLink: addToCalendarLink('pop up', setState, state)
      })
      return
    }
    setState({
      session
    })
  }).catch((error) => {
    setState({
      errorModalIsOpen: true,
      errorStatus: error.response.status,
      errorMessage: error.message
    })
    return
  })
}

export default postSessionRegistration